import { render, staticRenderFns } from "./Mfooter.vue?vue&type=template&id=12f5b044&scoped=true&"
import script from "./Mfooter.vue?vue&type=script&lang=js&"
export * from "./Mfooter.vue?vue&type=script&lang=js&"
import style0 from "./Mfooter.vue?vue&type=style&index=0&id=12f5b044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f5b044",
  null
  
)

export default component.exports